<script>
import BaseModal from '@/vcs/_shared/modals/BaseModal.vue'
import axios from 'axios'

export default {
  extends: BaseModal,
  data: function () {
    return {
      email: '', // "lukasz@enginearch.com"
      password: '', // "engine"
      deviceId: '' // "f0228c72bdd98ce1"
    }
  },
  methods: {
    signIn() {
      if (this.email && this.password && this.deviceId) {
        this.$blockUI()
        axios({
          method: 'post',
          url: '/auth/device_id_authorization',
          params: {
            email: this.email,
            password: this.password,
            deviceId: this.deviceId
          }
        })
          .then((response) => {
            if (response.status == 200) {
              window.localStorage.setItem('device_id', this.deviceId)
              this.$store.commit('setDeviceId', this.deviceId)
              this.close(this.deviceId) // refetch cp
            }
          })
          .catch((error) => {
            this.$errorHumanized(null, 'not authorized')
          })
          .finally(() => {
            this.$unblockUI()
          })
      }
    }
  }
}
</script>

<template lang="pug">
span
  .modal-header
    h4 {{ $t('modals.deviceIdModal.header') }}
  .modal-body
    form(@submit.prevent="signIn")
      .row
        .col-12
          .input-group.mb-3
            label.font-weight-bold Email
            input.form-control(
              type="email"
              v-model="email"
              @focus="$slideUp()"
              @blur="$slideDown()"
            )
          .input-group.mb-3
            label.font-weight-bold {{ $t('modals.deviceIdModal.password') }}
            input.form-control(
              type="password"
              v-model="password"
              @focus="$slideUp()"
              @blur="$slideDown()"
            )
          .input-group.mb-3
            label.font-weight-bold {{ $t('modals.deviceIdModal.deviceId') }}
            input.form-control(
              type="text"
              v-model="deviceId"
              @focus="$slideUp()"
              @blur="$slideDown()"
            )
      button.btn.btn-primary.btn-block(type="submit" @touchend.stop.prevent="signIn") {{ $t('modals.deviceIdModal.authorizeButton') }}
</template>
